import React from "react";

let holidays: Array<Date> = [new Date(2020, 2, 16)];

export const setHolidays = (value: Array<Date>) => {
    if (value instanceof Array) {
        holidays = value;
    }
}

const HolidaysContext = React.createContext({
    holidays,
    setHolidays
});

export default HolidaysContext;